<template>
  <div class="yellowTips">
    当前操作场景，暂无法实现获取正确的数据操作前内容，如有疑问，请找开发协助排查！
  </div>
  <Tooltip trigger="click">
    <template #title>
      <p>当前场景可能是以下任意1种场景：</p>
      <p>1. 列表数据的批量操作：可针对多条列表数据操作</p>
      <p>2. 表单页面操作：有多tab页，且不符合以下内容的场景</p>
      <p>- 所有tab页的操作1个接口处理&传所有tab更新内容</p>
      <p>- 1个tab页1个接口处理</p>
    </template>
    <span class="cursor-pointer text-blue-500">
      点击，查看场景说明
    </span>
  </Tooltip>
  <div class="mt-4">
    <h3 class="font-medium mb-2 text-sm">
      当前操作内容：
    </h3>
    <div class="border border-gray-300 p-2 rounded">
      {{ props.operationBody }}
    </div>
  </div>
</template>
<script setup lang="ts">
import { type LogInfo } from '../type'
import { defineProps } from 'vue'
import {
  Tooltip,
} from 'ant-design-vue'
const props = defineProps<LogInfo>()
</script>
<style lang="less">
.yellowTips {
  color: #faad14;
}

.fs-custom-modal {
  .code-diff-view {
    .file-header {
      display: none;
    }

    .diff-table {
      .blob-code-marker::before {
        content: none;
      }
    }
  }
}
</style>
